export default {"src":"/_next/static/media/caret_right.d2348994.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};